import { useCallback, useEffect, useState } from 'react';

import { getFlightTraces } from '~/services/FlightsService';

export function useFlightTraces(reservationIds: Array<string>) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [partialError, setPartialError] = useState<string | undefined>();
  const [data, setData] = useState<Array<App.FlightTraces>>([]);
  const reservationIdsKey = reservationIds.join(',');

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    setPartialError(undefined);

    try {
      const traces = await Promise.allSettled(reservationIdsKey.split(',').map(getFlightTraces));
      const successfulTraces = traces
        .filter((trace): trace is PromiseFulfilledResult<Awaited<ReturnType<typeof getFlightTraces>>> => {
          return trace.status === 'fulfilled';
        })
        .flatMap(({ value }) => value.result);
      const failedTraceRequests = traces.filter((trace) => trace.status === 'rejected').length;

      setData(successfulTraces);

      if (failedTraceRequests === traces.length) {
        setError('Failed to load flight logs');
      } else if (failedTraceRequests > 0) {
        setPartialError(`${failedTraceRequests} flight log request${failedTraceRequests === 1 ? '' : 's'} failed`);
      }
    } catch (error) {
      setError(error);
    }

    setLoading(false);
  }, [reservationIdsKey]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { loading, error, partialError, data, revalidate: fetchData };
}
